import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Select } from '../components/ui/Select';
import Title from '../components/ui/Title';
import { useUserData } from './UserDataContext';
import { getCookie, setCookie, deleteCookie } from '../util/Cookie';

const BenefitSelectedContext = createContext(undefined);

export const BenefitSelectedProvider = ({ children }) => {
    // busca do cookie ao iniciar
    const _init_ = getCookie("benefit_selected") || '';
    const [benefitSelected, setBenefitSelected] = useState(_init_);

    const setBenefit = (benefit) => {
        if (benefit) {
            setCookie("benefit_selected", benefit, 1); // expira em 1 dia
        } else {
            deleteCookie("benefit_selected");
        }
        setBenefitSelected(benefit);
        return benefit;
    };

    return (
        <BenefitSelectedContext.Provider value={{ benefitSelected, setBenefitSelected: setBenefit }}>
            {children}
        </BenefitSelectedContext.Provider>
    );
};

export const useBenefit = () => {
    const context = useContext(BenefitSelectedContext);
    if (!context) throw new Error('useBenefit deve ser usado dentro de BenefitSelectedProvider');
    return context;
};

let setModalSelectNbGlobal = null;

export default function ModalSelectNb() {
    const [open, setOpen] = useState(false);
    const { userData } = useUserData();
    const { benefitSelected, setBenefitSelected } = useBenefit();

    let user = userData;
    if (!userData) {
        const data = getCookie("user_data");
        user = data ? JSON.parse(data) : null;
    }

    // abre modal se não houver benefício
    useEffect(() => {
        setOpen(!benefitSelected);
    }, [benefitSelected]);

    setModalSelectNbGlobal = setOpen;

    const benefitOptions = useMemo(() => {
        if (!user?.beneficiosProdutos) return null;
        return user.beneficiosProdutos.map(nb => (
            <option key={nb.codigoBeneficio} value={nb.codigoBeneficio}>
                {nb.codigoBeneficio}
            </option>
        ));
    }, [user]);
    
    if (!open) return null;

    return (
        <div style={{ zIndex: 111 }} className="fixed inset-0 flex items-center justify-center bg-black/50 z-111">
            <div className="bg-white rounded-2xl p-6 w-80 shadow-lg">
                <Title text1={'Selecione'} text2={'Um Benefício'} />

                <Select
                    onChange={e => {
                        setBenefitSelected(e.target.value);
                        setOpen(false);
                    }}
                    value={benefitSelected}
                    variant="rounded"
                    label={'Benefícios'}
                    hiddenDefaultValue={!open}
                >
                    {benefitOptions}
                </Select>
            </div>
        </div>
    );
}